import React from 'react'

import DashboardPatientSummary from '../../components/DashboardPatientSummary'
import TeamActivityAccordion from '../../components/TeamActivityAccordion'
import ContentHeader from '../../containers/ContentHeader'
import SelectDropdown from '../../components/SelectDropdown'
import { getName, getWelcomeName } from '../../containers/Utilities'
import EcgLoader from '../../containers/EcgLoader'
import { HEADER_HEIGHT, BOTTOM_PADDING, EKG_REVIEW_PAGE_TABS, TRIAGE } from '../../constants'
import styles from './Dashboard.css'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'
import SingleLineIcon from 'static/images/icons/account-outline.svg'
import SingleSolidIcon from 'static/images/icons/account.svg'
import TriageLineIcon from 'static/images/icons/account-group-outline.svg'
import TriageSolidIcon from 'static/images/icons/account-group.svg'
import { needToBustCache, filterIsPhysicianPermission } from '../../store/appReducer'
import { checkRpmFeatureEnabled } from 'configs'
import AddNewPatientButton from '../../components/AddNewPatientButton'

class Dashboard extends React.Component {
  state = {
    accordions: {},
    innerHeight: 0,
    // innerWidth: 0,
  }

  UNSAFE_componentWillMount() {
    const {
      dataLastUpdated,
      getDashboardData,
    } = this.props

    getDashboardData(needToBustCache(dataLastUpdated))

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }

  handleOnPhysicianChange = physicianId => {
    this.props.updateSelectedPhysicianId(physicianId)
  }


  doToggleAccordion = name => {
    const {
      accordions,
    } = this.state
    const expanded = accordions[name] && accordions[name].expanded

    this.setState({
      accordions: {
        ...accordions,
        [name]: {
          expanded: !expanded,
        },
      },
    })
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      selectedPhysicianId,
      me,
      physicians,
      overview,
      activity,
      handleOnPatientFileNavClick,
      handleOnEkgReviewInboxClick,
      ekgStackCounts,
      getDashboardData,
    } = this.props
    const {
      accordions,
      innerHeight,
    } = this.state

    const contentHeight = innerHeight - HEADER_HEIGHT - BOTTOM_PADDING

    const connectionTypes = [
      'expired',
      'connected',
      'pending',
      'canceled',
    ]

    const isExpanded = connectionType => {
      const conn = accordions[connectionType]
      return conn && conn.expanded
    }

    let selectedPhysician = null
    let physicianOptions = []

    if (physicians.data) {
      physicianOptions = [
        ...physicianOptions,
        ...filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id])),
      ]
      if (selectedPhysicianId) {
        selectedPhysician = physicians.data.byId[selectedPhysicianId]
      }
    }

    let filteredPatientConnections = {}

    if (activity.data) {
      filteredPatientConnections = Object.keys(activity.data.patientConnections)
        .reduce((acc, conType) => {
          acc[conType] = activity.data.patientConnections[conType]
            .filter(conTypeItem => {
              const patient = conTypeItem.participant

              // return all patients
              if (!selectedPhysicianId) {
                return true
              }

              // A real physician has been selected by this point
              if (!patient.orderingPhysician) {
                return false
              }

              // Patient has ordering physician by this point
              return patient.orderingPhysician.id === selectedPhysicianId
            })
          return acc
        }, {})
    }

    const physicianIdForInbox = me.data ? me.data.profile.id : null
    if (!checkRpmFeatureEnabled(me)) {
      return (
        <div
          data-page="dashboard"
          className={styles.dashboard}
        >
          <AccessDeniedContent title="Dashboard" />
        </div>
      )
    }

    return (
      <div
        data-page="dashboard"
        className={styles.dashboard}
      >
        <ContentHeader
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={() => getDashboardData(true)}
          showAddPatient={!me.isFetching}
          showLastRefresh={!me.isFetching}
          enrollPatient={true}
          text="Dashboard"
          me={me}
        />

        {me.isFetching
          ? (
            <div
              className={styles.contentWrapper}
              style={{
                height: contentHeight,
              }}
            >
              <EcgLoader />
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height: contentHeight,
              }}
            >
              <div className={styles.welcomeRow}>
                <h1 className={styles.welcomeBackMsg}>
                  {me.data &&
                  <span>Welcome, <span>{getWelcomeName(me.data.profile.firstName, me.data.profile.lastName)}</span></span>
                  }
                </h1>
                {ekgStackCounts.data &&
                <div className={styles.ekgStackCounts}>
                  <div className={styles.label}>Personal Inbox</div>
                  <a
                    data-action="select-inbox-personal"
                    onClick={() => handleOnEkgReviewInboxClick(true, true, {
                      inboxId: physicianIdForInbox,
                    })}
                  >
                    <span className={styles.lineSvg}><SingleLineIcon /></span>
                    <span className={styles.solidSvg}><SingleSolidIcon /></span>
                    <span className={styles.badgeCount}>
                      {ekgStackCounts.data && ekgStackCounts.data.physicians.byId[physicianIdForInbox] !== undefined && ekgStackCounts.data.physicians.byId[physicianIdForInbox] }
                    </span>
                  </a>
                  <div className={styles.label}>Practice Inbox</div>
                  <a
                    data-action="select-inbox-triage"
                    onClick={() => handleOnEkgReviewInboxClick(true, true, {
                      inboxId: TRIAGE,
                    })}
                  >
                    <span className={styles.lineSvg}><TriageLineIcon /></span>
                    <span className={styles.solidSvg}><TriageSolidIcon /></span>
                    <span className={styles.badgeCount}>
                      {ekgStackCounts.data && ekgStackCounts.data.triage !== undefined && ekgStackCounts.data.triage}
                    </span>
                  </a>
                </div>
                }
              </div>
              <div className={styles.patientSummary}>
                {overview.data &&
                <DashboardPatientSummary
                  patientSummary={overview.data.patientSummary}
                />
                }
              </div>
              <div className={styles.monitoringSection}>
                <div className={styles.monitoringAccordionsHeader}>
                  <div className={styles.headerWrapper}>
                    <h2 className={styles.headerText}>
                      Connection Metrics
                    </h2>
                    <p className={styles.subtext}>
                      &mdash; Past 14 days
                    </p>
                  </div>
                  <div className={styles.toolbar}>
                    <div
                      className={styles.filter}
                      data-action="filter-ordering-provider"
                    >
                      <SelectDropdown
                        isLoading={physicians.isFetching}
                        isClearable={true}
                        backspaceRemovesValue={true}
                        placeholder="Ordering Provider"
                        value={selectedPhysician}
                        onChange={this.handleOnPhysicianChange}
                        options={physicianOptions}
                        noOptionsMessage="No Physicians found"
                        getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
                        getOptionValue={p => p.id}
                        className="dashboardSelect react-select-filter-selector"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={styles.monitoringAccordions}
                >
                  {connectionTypes.map((conn, i) => {
                    const connections = filteredPatientConnections[conn]
                    if (connections && connections.length > 0) {
                      return (
                        <TeamActivityAccordion
                          key={conn}
                          doToggleAccordion={this.doToggleAccordion}
                          expanded={isExpanded(conn)}
                          connections={connections}
                          connectionType={conn}
                          navigateToPatient={id => handleOnPatientFileNavClick(true, true, { patientId: id })}
                          me={me}
                        />
                      )
                    } else {
                      return (
                        <TeamActivityAccordion
                          key={conn}
                          doToggleAccordion={() => { }}
                          expanded={false}
                          connections={[]}
                          connectionType={conn}
                          navigateToPatient={() => { }}
                          templates={[]}
                          me={me}
                        />
                      )
                    }
                  })}
                </div>
              </div>
            </div>
          )
        }

        {/* {me.data
          && (
            <Help
              learnMoreIndex={0}
              previousLoginAt={me.data.profile.previousLoginAt}
              lastLoginAt={me.data.profile.lastLoginAt}
            />
          )
        } */}
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/legacy/pages/Dashboard/Dashboard.jsx